import { Component } from '@angular/core';
import { VerbalService } from 'src/app/modules/read-aloud/services/verbal.service';
import { VerbalAudioType } from 'src/app/modules/read-aloud/services/verbal.service';
import { AudioType } from 'src/app/shared/enums/audio-type';
import { AudioDescriptor } from 'src/app/shared/enums/audio-descriptor';

@Component({
  selector: 'htc-verbal-hints-button',
  templateUrl: './verbal-hints-button.component.html',
  styleUrls: ['./verbal-hints-button.component.scss'],
  standalone: false,
})
export class VerbalHintsButtonComponent {
  readonly path = '/assets/toolbar-icons/';
  icon = 'verbal_hints_unheard.png';
  testId = 'htc-verbal-hints-button';
  clickDescriptor = AudioDescriptor.SELECT_MINOR;
  clickType = AudioType.audio_SfxClick;

  constructor(private verbalService: VerbalService) {}

  onClick(): void {
    this.verbalService.playPopulationAudio(VerbalAudioType.HINT);
  }
}
